import React from 'react';
import { Icons } from '../../../components/atoms/SVG';
import { StatusInfo, StatusInfoModifier } from './partials/StatusInfo';
import { Content } from './partials/Content';
import { Message } from './partials/Message';
import { Icon } from './partials/Icon';

type StatusInfoIncomplete = { message: string; modifier?: StatusInfoModifier };

export function StatusInfoIncomplete({ message, modifier }: StatusInfoIncomplete) {
  return (
    <StatusInfo modifier={modifier}>
      <Content>
        <Icon icon={Icons.EDIT_CIRCLE_PENCIL} />
        <Message>{message}</Message>
      </Content>
    </StatusInfo>
  );
}
